export default __webpack_public_path__ + "static/media/empty.2ce54e81.png";